/**
 * Get schools
 * @returns {Array} - List of schools
 */
export async function getSchools() {
  const result = await fetch(
    `https://project-milwaukee-public-schools-facility-master-plan.s3.amazonaws.com/mps_schools_250321.geojson`,
    {
      method: "GET",
      mode: "cors",
    },
  );
  if (result.ok) {
    const data = await result.json();
    return await data["features"];
  }
  throw new Error(result.statusText);
}
